// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__3g0Vt","modal":"Modal_modal__N1+WB","header":"Modal_header__Py3e0"};